var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAni8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0836 12.3547V18.5827C12.038 18.9939 11.8108 19.2587 11.402 19.3771C10.9932 19.4971 10.5884 19.3931 10.1876 19.0651L0.48443 10.8595C0.358002 10.755 0.256432 10.6237 0.187103 10.4751C0.117775 10.3265 0.0824261 10.1643 0.0836296 10.0003C0.0836296 9.66429 0.21723 9.37709 0.48443 9.13869L10.2524 0.877893C10.6524 0.601093 11.0444 0.519094 11.4284 0.631893C11.8124 0.744694 12.0308 0.989893 12.0836 1.36749V7.65309L20.0204 0.935492C20.4172 0.618692 20.8356 0.517494 21.2756 0.631893C21.7148 0.746294 21.9284 0.991493 21.9164 1.36749L21.9164 18.4843C21.9284 18.8787 21.748 19.1635 21.3752 19.3387C21.0016 19.5147 20.5736 19.4459 20.0912 19.1323L12.0836 12.3547Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAni8);
export default __webpack_public_path__ + "static/media/Ani8.7ad81dea93c637331ed2d1b1f0979d01.svg";
export { ForwardRef as ReactComponent };